/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  belongsTo,
  attr,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from 'linced-app/models/school';

// Proto: finance.CostCentre.
export default class CostCentre extends Model {
  declare [Type]: 'finance/cost-centre';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  // code is the Cost Centre's name/code.
  @attr('string', { defaultValue: '' })
  declare code: string;

  // description is a human-readable description of the Cost Centre.
  @attr('string', { defaultValue: '' })
  declare description: string;

  // isActive flags whether the Cost Centre is active.
  @attr('boolean', { defaultValue: false })
  declare isActive: boolean;

  @computed('code', 'description')
  get displayName() {
    if (isEmpty(this.description)) {
      return this.code;
    }
    return `${this.code} - ${this.description}`;
  }
}
